/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  contain: content;
  display: inline-block;
  vertical-align: middle;
  min-height: calc(16rem/14);
  overflow: hidden;
}
:host :focus {
  outline: none;
}
:host #icon {
  top: calc(1rem/14);
  margin: 0 calc(-1rem/14);
}
:host svg {
  fill: #B4BEC5;
  fill: var(--davinci-color-outline, #B4BEC5);
}
:host .breadcrumb-item {
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
  text-decoration: none;
  background-color: transparent;
  line-height: calc(16rem/14);
  font-size: calc(12rem/14);
  font-weight: bold;
  margin-left: calc(6rem/14);
}
:host .breadcrumb-item:hover {
  color: #009DF4;
  color: var(--davinci-color-primary-light, #009DF4);
}

:host(:first-child) #icon {
  display: none;
}
:host(:first-child) .breadcrumb-item {
  margin-left: 0;
}

:host(:last-child) .breadcrumb-item {
  font-weight: normal;
  cursor: default;
  pointer-events: none;
}
:host(:last-child) .breadcrumb-item:hover {
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
}`;
export { style };
//# sourceMappingURL=BreadcrumbItem.style.js.map